import a from '@/utils/axios/axios'

const noti = {
  namespaced: true,
  state: () => ({
    maps: [],
    map_bases: [],
    chosen_map_base_id: null
  }),
  mutations: {
    ADD_MAP(state, map) {
      state.maps = state.maps.concat(map)
    },
    SET_MAPS(state, maps) {
      state.maps = maps
    },
    PUT_MAP(state, map) {
      let mod = state.maps
      let i = mod.findIndex(e => e.id == map.id)

      mod[i] = map

      state.maps = mod
    },
    REMOVE_MAP(state, id) {
      let mod = state.maps
      mod = mod.filter(e => e.id != id)

      state.maps = mod
    },
    SET_MAP_BASES(state, bases) {
      state.map_bases = bases
    },
    SET_CHOSEN_MAP_BASE_ID(state, id) {
      state.chosen_map_base_id = id
    },
    UPDATE_POINT_OF_INTEREST(state, { name, ideal_x, ideal_y }) {
      const base = state.map_bases.find(b => b.id === state.chosen_map_base_id);
      if (!base) return;
      let dims;
      try {
        dims = JSON.parse(base.dimensions);
      } catch (e) {
        return;
      }
      if (!dims.points_of_interest) return;
      const poi = dims.points_of_interest.find(p => p.name === name);
      if (poi) {
        poi.ideal_x = ideal_x;
        poi.ideal_y = ideal_y;
        base.dimensions = JSON.stringify(dims);
      }
    }
  },
  actions: {
    postMap({ commit, rootGetters } , map) {
      const teamId = rootGetters['user/currentTeamId']

      return new Promise((resolve, reject) => {
        a.post('/maps', { ...map, team_id: teamId })
          .then(e => {
            resolve(e.data)
            commit('ADD_MAP', e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    initMaps({ commit, rootGetters }) {
      const teamId = rootGetters['user/currentTeamId']
      return new Promise((resolve, reject) => {
        a.get(`/maps/team/${teamId}`)
          .then(e => {
            resolve(e.data)
            commit('SET_MAPS', e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    initLeagueMapBases({ commit }, { league_id, open_type }) {
      return new Promise((resolve, reject) => {
        a.get(`/maps/base/league/${league_id}`)
          .then(e => {
            resolve(e.data)
            commit('SET_MAP_BASES', e.data)
            if(!e.data || !e.data.length) return

            const choose = open_type && e.data.find(e => e.map_type == open_type)
              ? e.data.find(e => e.map_type == open_type)
              : e.data[0]
            commit('SET_CHOSEN_MAP_BASE_ID', choose.id)

          })
          .catch(e => {
            reject(e)
          })
      })
    },
    initSportMapBases({ commit, rootGetters }, sport_id) {
      sport_id = sport_id || rootGetters['template/sport_id']
      return new Promise((resolve, reject) => {
        a.get(`/maps/base/sport/${sport_id}`)
          .then(e => {
            resolve(e.data)
            commit('SET_MAP_BASES', e.data)
            if(!e.data || !e.data.length) return
            commit('SET_CHOSEN_MAP_BASE_ID', e.data[0].id)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getMap(_, { id }) {
      return new Promise((resolve, reject) => {
        a.get(`/maps/${id}`)
          .then(e => {
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    editMap({ commit }, { id, title, description, points }) {
      return new Promise((resolve, reject) => {
        a.put(`/maps/${id}`, { title, description, points })
          .then(e => {
            commit('PUT_MAP', e.data)
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    deleteMap({ commit }, id) {
      return new Promise((resolve, reject) => {
        a.delete(`/maps/${id}`)
          .then(e => {
            commit('REMOVE_MAP', id)
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getMapBases({ commit, rootGetters }) {
      const team_id = rootGetters['user/currentTeamId']
      return new Promise((resolve,reject) => {
        a.get(`/maps/base/team/${team_id}`)
          .then(e => {
            commit('SET_MAP_BASES', e.data)
            resolve(e)
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })

      })
    },
    updatePointOfInterest({ commit }, payload) {
      commit('UPDATE_POINT_OF_INTEREST', payload);
    }
  },
  getters: {
    maps: state => state.maps,
    map_bases: state => state.map_bases,
    chosen_map_base_id: state => state.chosen_map_base_id,
    chosen_map_base: state => {
      if(!state.chosen_map_base_id) return null
      return state.map_bases.find(e => e.id == state.chosen_map_base_id)
    }
  }
}

export default noti